import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import styles from './screenshot.module.css';

/** kaneai InstructionStatusBar segment colors (spec §statusBar). */
import { jsx as _jsx } from "react/jsx-runtime";
var segmentColor = function segmentColor(status, selected) {
  if (selected) return '#0969DA';
  switch (status) {
    case 'passed':
      return '#1F883D';
    case 'failed':
      return '#CF222E';
    case 'executing':
      return '#0969DA';
    default:
      return '#6E7781';
  }
};

/** macOS-dock magnification: heights/gaps by distance from the hovered
 * segment (DOCK_HEIGHTS / DOCK_GAPS). */
var heightFor = function heightFor(distance) {
  if (distance === null) return 6;
  if (distance === 0) return 14;
  if (distance === 1) return 11;
  if (distance === 2) return 8;
  return 6;
};
var gapFor = function gapFor(distance) {
  if (distance === null) return 2;
  if (distance === 0) return 5;
  if (distance === 1) return 4;
  if (distance === 2) return 3;
  return 2;
};

/**
 * Port of kaneai's InstructionStatusBar: one flex-1 rounded segment per
 * step, colored by status (selected = solid blue), 18px hover band with
 * dock magnification. Click/Enter selects the step.
 */
export function StatusBar(_ref) {
  var steps = _ref.steps,
    selectedKey = _ref.selectedKey,
    displayStatus = _ref.displayStatus,
    onSelect = _ref.onSelect;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  if (steps.length === 0) return null;
  return /*#__PURE__*/_jsx("div", {
    className: styles.statusBar,
    role: "tablist",
    "aria-label": "Instruction status",
    onMouseLeave: function onMouseLeave() {
      return setHovered(null);
    },
    children: steps.map(function (step, i) {
      var _step$ordinal;
      var status = displayStatus(step);
      var selected = selectedKey === step.key;
      var skipped = status === 'skipped';
      var distance = hovered === null ? null : Math.abs(i - hovered);
      return /*#__PURE__*/_jsx("div", {
        className: styles.statusSegment,
        style: {
          backgroundColor: segmentColor(status, selected),
          height: heightFor(distance),
          marginRight: i === steps.length - 1 ? 0 : gapFor(distance),
          cursor: skipped ? 'default' : 'pointer'
        },
        role: "tab",
        "aria-selected": selected,
        "aria-label": "Step ".concat((_step$ordinal = step.ordinal) !== null && _step$ordinal !== void 0 ? _step$ordinal : i + 1, ": ").concat(step.title, ", ").concat(status),
        tabIndex: skipped ? -1 : 0,
        onMouseEnter: function onMouseEnter() {
          return setHovered(i);
        },
        onClick: function onClick() {
          return !skipped && onSelect(step.key);
        },
        onKeyDown: function onKeyDown(e) {
          if (!skipped && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onSelect(step.key);
          }
        },
        children: /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          className: styles.statusSegmentHit
        })
      }, step.key);
    })
  });
}